import { Card, Dropdown, Modal } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import Lonely from "../../../app/assets/images/lonely-icon.png";
import { useState } from "react";
import ModalTable from "./list/ModalTable";
import PropTypes from "prop-types";
import { useDashboard } from "../../../app/hooks/useDashboard";

const TotalAbsent = (props) => {
  TotalAbsent.propTypes = {
    count: PropTypes.array.isRequired,
  };

  const { count: totalAbsent } = props;
  const [isCoreModalVisible, setIsCoreModalVisible] = useState(false);
  const [isProjectBasedModalVisible, setIsProjectBasedModalVisible] =
    useState(false);
  const [absentData, setAbsentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getTotalAbsent } = useDashboard();

  const showCoreModal = async () => {
    setLoading(true);
    try {
      const data = await getTotalAbsent({ employeeType: "core" });
      setAbsentData(data);
      setIsCoreModalVisible(true);
    } catch (error) {
      console.error("Failed to fetch absent data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsCoreModalVisible(false);
    setIsProjectBasedModalVisible(false);
  };

  const showProjectBasedModal = async () => {
    setLoading(true);
    try {
      const data = await getTotalAbsent({ employeeType: "contractual" });
      setAbsentData(data);
      setIsProjectBasedModalVisible(true);
    } catch (error) {
      console.error("Failed to fetch absent data:", error);
    } finally {
      setLoading(false);
    }
  };

  const items = [
    {
      label: <p onClick={showCoreModal}>CORE</p>,
    },
    {
      type: "divider",
    },
    {
      label: <p onClick={showProjectBasedModal}>PROJECT BASED</p>,
    },
  ];

  return (
    <Card className="summary-count-card">
      <Dropdown menu={{ items }} className="dropdown-btn" trigger={["click"]}>
        <button className="modal-btn">
          <EllipsisOutlined className="dropdownIcon" />
        </button>
      </Dropdown>
      <Modal
        open={isCoreModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={1000}
        destroyOnClose
      >
        <h3 className="summary-modal-title">Core</h3>
        <ModalTable data={absentData} loading={loading} />
      </Modal>
      <Modal
        open={isProjectBasedModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={1000}
        destroyOnClose
      >
        <h3 className="summary-modal-title">Project Based</h3>
        <ModalTable data={absentData} loading={loading} />
      </Modal>

      <div className="summary-count-card">
        {/* temporary */}
        <img src={Lonely} alt="Your Logo" className="icon2" />
        <div>
          <h1 className="cardNum">{totalAbsent}</h1>
          <p className="cardDes">Total Absent</p>
        </div>
      </div>
    </Card>
  );
};

export default TotalAbsent;
